import Search from "./search/index";
import StoreTile from "./store-tile/index";
import style from "./style.module.scss";
import { useCallback, useEffect, useState } from "react";

const Header = ({
  map,
  resellerList,
  selectedReseller,
  setSelectedReseller,
  setPendingCenter,
  isLoading,
  setIsLoading,
  countryCode,
}) => {
  const [hasScroll, setHasScroll] = useState(false);
  const [userLocation, setUserLocation] = useState(null);

  // Fonction pour demander la géolocalisation
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.log("Géolocalisation refusée ou erreur:", error);
        }
      );
    }
  }, []);

  const checkForScroll = useCallback(() => {
    const list = document.getElementById("closestBiogentsResellerListScroll");
    if (!list) return;

    const hasVerticalScroll = list.scrollHeight > list.clientHeight;
    setHasScroll(hasVerticalScroll);
  }, []);

  useEffect(() => {
    checkForScroll();
    // Optionnel : vérifier aussi lors du redimensionnement de la fenêtre
    window.addEventListener("resize", checkForScroll);
    return () => window.removeEventListener("resize", checkForScroll);
  }, [checkForScroll, resellerList, selectedReseller, isLoading]);

  const centerAndResize = useCallback(
    (e) => {
      if (map) {
        let values = e.result
          ? e.result.center
          : [e.coords.longitude, e.coords.latitude];
        map.flyTo({
          center: values,
          zoom: 10,
          speed: 1,
        });
        setPendingCenter(values);
        setIsLoading(true);
      }
    },
    [map, setPendingCenter, setIsLoading]
  );

  useEffect(() => {
    const list = document.getElementById("closestBiogentsResellerListScroll");
    if (!list) return;
    list.scrollTo(0, 0);
  }, [selectedReseller]);

  return (
    <div className={style.mapHeader} id="biogents-resellers-filters">
      <Search
        map={map}
        centerAndResize={centerAndResize}
        countryCode={countryCode}
      />

      <div
        className={style.closestResellerList}
        id="closestBiogentsResellerListScroll"
      >
        {isLoading ? (
          <div className={style.loadingResellersList}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 38 38"
            >
              <g fill="none" transform="translate(1 1)">
                <circle cx="18" cy="18" r="18" stroke="#0080be" />
                <path stroke="#ffffff" d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform
                    attributeName="transform"
                    dur="1s"
                    from="0 18 18"
                    repeatCount="indefinite"
                    to="360 18 18"
                    type="rotate"
                  />
                </path>
              </g>
            </svg>
          </div>
        ) : (
          <>
            {resellerList?.length <= 0 && selectedReseller !== null ? (
              <StoreTile
                isMain={true}
                store={selectedReseller}
                userLocation={userLocation}
                withoutPadding={!hasScroll}
              />
            ) : (
              resellerList.map((element, index) => (
                <StoreTile
                  key={index}
                  isMain={
                    element?.properties.id === selectedReseller?.properties.id
                  }
                  store={element}
                  setSelectedReseller={setSelectedReseller}
                  map={map}
                  userLocation={userLocation}
                />
              ))
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
